<template>
	<div class="app-container" id="page" @click="resetVersionCheck">
        <DefaultLayout :showDashboard="showDashboard" :hideHeader="hideHeader" :hideFooter="hideFooter" :fondo="fondo">
			<router-view />
		</DefaultLayout>
        <Bot v-if="!hideBot" id="whatsapp-chat" />
        <AppVersionCheck />
        <CookiesConsent />
        <NotificacionesToasts />
	</div>
</template>

<script>
import NotificacionesToasts from "@/components/Notificaciones/NotificacionesToasts.vue";
import CookiesConsent from "@/components/Cookies/Cookies";
import WebSitePopUp from "@/components/PopUps/WebSitePopUp";
import Bot from "@/components/Bot/Bot.vue";
import AppVersionCheck from "@/components/AppVersionCheck/AppVersionCheck.vue";
import store from '@/store'
import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default {
	components: {
        NotificacionesToasts,
        CookiesConsent,
        WebSitePopUp,
        Bot,
        AppVersionCheck,
        DefaultLayout
	},
	computed: {
		showDashboard() {
			return this.$route.meta.showDashboard === true;
		},
        hideBot() {
            return this.$route.meta.hideBot;
        },
        hideHeader() {
            return this.$route.meta.hideHeader === true;
        },
        hideFooter() {
            return this.$route.meta.hideFooter === true;
        },
        // Fondo de marca: en todas las rutas salvo las que piden `fondo: false`
        // (la portada). Hasta que el router resuelve la primera ruta no se
        // muestra, para que no aparezca un instante en la portada.
        fondo() {
            return this.$route.matched.length > 0 && this.$route.meta.fondo !== false;
        }
	},
    methods: {
        resetVersionCheck() {
            store.dispatch('appVersionCheck/setVersionChecked', false);
        },
    }
};
</script>

<style>

.app-container {
    font-family: 'Instrument Sans', sans-serif;
}

</style>

